import css from './Group.module.scss'
import React, { useState } from 'react'
import { Range } from 'react-input-range'
import classNames from 'classnames'

import { ITicketGroup } from 'meta/backendControlled/structure/ticket'
import { Breakpoints } from 'meta/layout/breakpoints'
import { ICheckoutDetails } from 'meta/pages/checkout'

import GroupMap from 'components/BackendControlled/Component/EventTicket/GroupMap'
import Automatic from 'components/Checkout/TicketSelection/Automatic'
import Filters from 'components/Checkout/TicketSelection/Filters'
import { GridColumn } from 'components/Layout/Grid'
import { useCheckoutDetails } from 'hooks/useCheckout'

interface IProps {
  groupData: ITicketGroup
}

const Group: React.FC<IProps> = (props) => {
  const { groupData } = props

  const { eventTicket } = useCheckoutDetails() as ICheckoutDetails
  const { data } = eventTicket

  const minPrice = Math.min(...data.filter((x) => groupData.typeTicketIds.includes(x.id)).map((x) => x.priceNumber))
  const maxPrice = Math.max(...data.filter((x) => groupData.typeTicketIds.includes(x.id)).map((x) => x.priceNumber))
  const priceRangeInitial: Range = { min: minPrice, max: maxPrice }
  const [priceRangeCurrent, setPriceRangeCurrent] = useState<Range>({
    min: minPrice,
    max: maxPrice,
  })

  return (
    <GridColumn
      gridColumnStart={{ [Breakpoints.laptop]: 2, [Breakpoints.mobile]: 1 }}
      gridColumnEnd={{ [Breakpoints.laptop]: 16, [Breakpoints.mobile]: 17 }}
    >
      <div className={classNames(css.container)}>
        <h3>{groupData.name}</h3>

        {groupData?.cover?.url && <GroupMap insideCheckout bgImageUrl={groupData.cover.url} />}

        {groupData.typeTicketIds.length > 1 && (
          <Filters
            priceRangeInitial={priceRangeInitial}
            priceRangeCurrent={priceRangeCurrent}
            setPriceRangeCallback={setPriceRangeCurrent}
          />
        )}

        <Automatic
          isGroup={true}
          priceRangeCurrent={priceRangeCurrent}
          ticketsData={data.filter((x) => groupData.typeTicketIds.includes(x.id))}
        />
      </div>
    </GridColumn>
  )
}

export default Group
